import { VIEWER_SET_SHOW_REJECT_MODAL } from '../actions';

export default function setShowRejectModal(show) {
  return {
    type: VIEWER_SET_SHOW_REJECT_MODAL,
    show,
  };
}
